/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Body2Inputs */

const en_to_csv_body2 = /** @type {(inputs: To_Csv_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The answers here are the pragmatic ones. The header row is the union of every key seen across every record, in the order the keys were first encountered. A record missing one of those keys gets an empty cell. A value that is itself an object or an array is written into the cell as JSON text. Nothing is dropped, but a nested structure arrives in the spreadsheet as a string rather than as columns.`)
};

const ko_to_csv_body2 = /** @type {(inputs: To_Csv_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여기서의 답은 실용적인 쪽입니다. 헤더 행은 모든 레코드에서 발견된 모든 키의 합집합이며, 키가 처음 등장한 순서를 따릅니다. 그 키가 없는 레코드는 빈 칸을 받습니다. 값 자체가 객체나 배열이면 JSON 텍스트로 칸에 기록됩니다. 버려지는 것은 없지만, 중첩 구조는 열이 아니라 문자열로 스프레드시트에 도착합니다.`)
};

const ja_to_csv_body2 = /** @type {(inputs: To_Csv_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここでの答えは実用的な側です。ヘッダ行はすべてのレコードで見つかったすべてのキーの和集合で、キーが最初に現れた順に並びます。そのキーを持たないレコードは空のセルを受け取ります。値そのものがオブジェクトや配列なら、JSON テキストとしてセルに書かれます。捨てられるものはありませんが、ネストした構造は列ではなく文字列として表計算に届きます。`)
};

/**
* | output |
* | --- |
* | "The answers here are the pragmatic ones. The header row is the union of every key seen across every record, in the order the keys were first encountered. A r..." |
*
* @param {To_Csv_Body2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_body2 = /** @type {((inputs?: To_Csv_Body2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Body2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_body2(inputs)
	if (locale === "ko") return ko_to_csv_body2(inputs)
	return ja_to_csv_body2(inputs)
});